import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';

import api from 'api';

import css from 'css';

import { redirect404, gtmPush, decodeHtml } from 'helpers';

import Builder from 'partials/Builder';
import HeadMeta from 'partials/HeadMeta';
import Footer from 'partials/Footer';
import ErrorBoundary from 'partials/ErrorBoundary';
import NotFound from 'partials/NotFound'

import {
    setCurrentView
} from 'store';

const Wrapper = styled.div`
    display:block;
    background: white;
    position:relative;
    width:100%;

    &.blue-background {
        background: ${css.colors.blue};
    }
`

class CategoryPage extends Component {

    constructor(props) {
        super(props)

        this.state = {
            notFound: false
        }
    }

    componentDidMount() {
        this.mounted = true;

        this._loadCategories();
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this._loadCategories();
        }
    }

    _loadCategories() {
        api.categoriesFetcher.getBySlug({ slug: this.props.match.params.slug }).then(resp => {
            if (!resp.data[0]) {
                api.academicAreasFetcher.getBySlug({ slug: this.props.match.params.slug }).then(resp => {
                    if (!resp.data[0]) {
                        this.setState({ notFound: true })
                    } else {
                        this._processPageResponse(resp.data[0]);
                    }
                });
            } else {
                this._processPageResponse(resp.data[0]);
            }
        });
    }

    _processPageResponse(respose) {
        if (!this.mounted) {
            return;
        }

        this.props.setCurrentView(respose);

        if (window.firstLoad !== false) {
            return;
        }

        let title = respose.yoast.title;

        if (!title && respose.title && respose.title.rendered) {
            title = respose.title.rendered;
        }

        if (!title && respose.post_title) {
            title = respose.post_title;
        }

        if (!title && respose.name) {
            title = respose.name;
        }

        gtmPush({
            'event': 'pageview',
            'page': {
                'path': this.props.location.pathname,
                'title': decodeHtml(title)
            }
        });

        window.firstLoad = false;
    }

    render() {
        const { category, academicArea } = this.props;

        const page = category ? category : academicArea;

        if(this.state.notFound) return <NotFound/>

        if (!page) {
            return null;
        }

        return (
            <Wrapper className={page && page.acf && page.acf.page_background ? page.acf.page_background + '-background' : ''}>
                <HeadMeta page={page} />
                <ErrorBoundary for="Page builder">
                    <Builder data={page.acf.modules || []} page={page} />
                </ErrorBoundary>
                <ErrorBoundary for="Footer">
                    <Footer />
                </ErrorBoundary>
            </Wrapper>
        );
    }
}

const mapStateToProps = (state, props) => ({
    category: state.categories.posts.filter(category => category.slug === props.match.params.slug)[0],
    academicArea: state.academicAreas.posts.filter(academicArea => academicArea.slug === props.match.params.slug)[0]
});

const actions = {
    setCurrentView,
}

export default connect(mapStateToProps, actions)(withRouter(CategoryPage));



// WEBPACK FOOTER //
// ./src/views/CategoryPage.js